import { render, staticRenderFns } from "./TheCard.vue?vue&type=template&id=051aaf02&scoped=true"
import script from "./TheCard.vue?vue&type=script&lang=ts"
export * from "./TheCard.vue?vue&type=script&lang=ts"
import style0 from "./TheCard.vue?vue&type=style&index=0&id=051aaf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051aaf02",
  null
  
)

export default component.exports